export default __webpack_public_path__ + "static/media/logo_small.9d0678c1.svg";